var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"selectable-chip",attrs:{"selected":false,"outline":!_vm.active,"color":_vm.activeChipColor,"text-color":_vm.getTextColor},on:{"click":_vm.toggleActive}},[_vm._t("icon",null,{"active":_vm.active,"currentColor":_vm.getConditionalColor}),_vm._v(_vm._s(_vm.chipName))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }